import {API} from "../lib/axios";
import { bake_cookie } from "../lib/cookies-service";
import {Network} from "../lib/types.ts";


export async function fetchNetwork(): Promise<Network | null> {
    try {
        const res = await API.get("/network");
        const network = res.data as Network;
        bake_cookie("zooza-network-id", network?.id);
        return network;
    } catch (error) {
        console.error("Failed to fetch network:", error);
        return null;
    }
}
